
//接口名称
var api = {

  upload: '/app/Upload/upload',//上传图片

  index: '/app/Gzh/index',//首页接口
  type_list: '/app/Appindex/type_list',//素材/作品分类列表
  video_list: '/app/video/list',//视频列表
  detail: '/app/video/detail',//视频详情
  collect_list: '/app/collect/video_list',// 订阅视频
  collect: '/app/Video/collect',// 收藏/取消收藏视频教程
  open_video: '/app/video/open_video',//播放视频记录学习


  member_info: '/app/Member/info',//个人中心/个人信息
  vip_pay_list: '/app/Appindex/vip',//VIP页面数据
  apply_vip: '/app/Member/apply_vip',//生成支付订单
  pay: '/app/pay/pay',//VIP订单调起支付
  bind_mobile: '/app/Account/bind_mobile',//VIP订单调起支付
  get_yzm: '/app/Account/yzm',//获取验证码
  gzh_login: '/app/Gzh/login',//公众号登录注册
  wx_code_url: '/app/Account/wx_code_url',//获取微信code
  wx_userinfo: '/app/Account/wx_userinfo',//获取微信openid
  getSignPackage: '/app/wechat/getSignPackage',//获取微信openid








}

export default api;










// WEBPACK FOOTER //
// ./src/api/api.js